import axios from 'axios';

export const requestResetPassword = async (values, recaptchaToken) =>
  axios.post(
    `/users/reset-password`,
    { ...values },
    {
      headers: {
        'X-Recaptcha-Token': recaptchaToken,
      },
    },
  );

export const verifyResetPassword = async values => axios.post(`/users/reset-password/verify`, { ...values });

export default { requestResetPassword, verifyResetPassword };
